import { Fragment } from "react";
import PhoneNumberGetter from "./PhoneNumberGetter";
import Tutorials from "./Tutorials";
import BuyVoucher from "./BuyVoucher";
import HowItWorks from "./HowItWorks";


const Home = () => {

    return (
        <Fragment>
            <PhoneNumberGetter />
            <BuyVoucher />
            <HowItWorks />
            <Tutorials />
        </Fragment>
    );
};

export default Home;
